import { apiProducts } from "./api";

//Impressão de Pré-conta módulo Mesa
export const saleInProgressPrint = (params) => {
  return apiProducts.post("/api/printers/sale-in-progress/pre-order", params);
};
